import { Navigate } from 'react-router-dom'

export default function RedirectRestaurants() {
  return <Navigate to={'/targets/commercial/restaurants-bars/'} />
}
